import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  grayScale,
  mBody2,
  mHeader1,
  mHeader2,
  wBody2,
  wHeader2,
  wTitle1,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  ${DESKTOP} {
    width: initial;
  }
`;

export const Title = styled.h1<{ course?: string }>`
  ${mHeader1};
  color: ${({ course }) =>
    course === "mkt" ? grayScale.white : ""} !important;
  text-align: left;
  ${DESKTOP} {
    padding: 0;
    ${wHeader2};
    text-align: center;
    br {
      &.mk-mo {
        display: none;
      }
    }
  }
`;

export const PointWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 50px;
  gap: 50px;
  ${DESKTOP} {
    margin: 0 auto;
    padding-top: 80px;
    flex-direction: row;
    width: 1152px;
    gap: 80px;
    @media (max-width: 1152px) {
      width: 950px;
      gap: 40px;
    }
  }
`;

export const Point = styled.div`
  ${DESKTOP} {
    width: 330px;
  }
`;

export const PointImg = styled.div`
  width: 80px;
  ${DESKTOP} {
    width: 100px;
  }
`;

export const PointTitle = styled.p<{ course?: string }>`
  ${mHeader2};
  color: ${({ course }) =>
    course === "mkt" ? grayScale.white : ""} !important;
  position: relative;
  white-space: pre-wrap;
  padding: 24px 0 12px;
  ${DESKTOP} {
    ${wTitle1};
    padding: 36px 0 16px;
  }
`;

export const PointDesc = styled.p<{ course?: string }>`
  ${mBody2};
  color: ${({ course }) =>
    course === "mkt" ? "#e0e8ec" : grayScale.gray70} !important;
  position: relative;
  white-space: pre-wrap;
  ${DESKTOP} {
    ${wBody2};
  }
`;
